// extracted by mini-css-extract-plugin
export default {"wrapper":"load-bot-message_wrapper__zDtQO","bounceIn":"load-bot-message_bounceIn__rxqYi","dot":"load-bot-message_dot__cNPw4","pulse":"load-bot-message_pulse__O6IyS"};